import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { FaresHttpService } from './fares.http';
import { objectToCamel, objectToSnake } from 'ts-case-convert';
import { IFare } from 'src/app/models';
import { FareType } from 'src/app/models/enums';

@Injectable({
  providedIn: 'root'
})
export class FaresService {

  constructor(private faresHttpService: FaresHttpService) { }

  async getFares(clientId: number, size?: number, page?: number, name?: string, includeInactive?: boolean): Promise<IFare[]> {
    const source$ = this.faresHttpService.getFares(clientId, size, page, name, includeInactive);
    const response = await lastValueFrom(source$);
    const data = objectToCamel(response as object) as any;
    return data.content || data;
  }

  async getFare(id: number, type: FareType): Promise<IFare> {
    const source$ = this.faresHttpService.getFare(id, type);
    const response = await lastValueFrom(source$);
    return objectToCamel(response as object) as IFare;
  }

  async createFare(fare: any, type: FareType): Promise<IFare> {
    const requestBody = objectToSnake(fare);
    const source$ = this.faresHttpService.createFare(requestBody, type);
    const response = await lastValueFrom(source$);
    return objectToCamel(response as object) as IFare;
  }

  async updateFare(id: number, fare: any, type: FareType): Promise<IFare> {
    const requestBody = objectToSnake(fare);
    const source$ = this.faresHttpService.updateFare(id, requestBody, type);
    const response = await lastValueFrom(source$);
    return objectToCamel(response as object) as IFare;
  }

  async deactivateFare(id: number): Promise<void> {
    const source$ = this.faresHttpService.deactivateFare(id);
    await lastValueFrom(source$);
  }

  async activateFare(id: number): Promise<void> {
    const source$ = this.faresHttpService.activateFare(id);
    await lastValueFrom(source$);
  }
}
